module.exports = {
  en: {
    'HRES37UC1': {
      '0': 'Approve Request for  Working Reference',
      '10': '[HRES37U] Approve Request for working reference',
      '20': 'No.',
      '30': 'Req.Date',
      '35': 'Seq No.',
      '40': 'Emp.Code  ',
      '50': 'Name',
      '60': 'Current Status ',
      '70': 'Approved By',
      '80': 'Appr. Date',
      '90': 'Remark',
      '100': 'Next Approve',
      '110': 'Certificate format'
    },
    'HRES37UC2': {
      '0': 'Detais Of Approvel',
      '10': 'For  Employee',
      '20': 'Approve No.',
      '30': 'Approved by',
      '40': 'Date',
      '50': 'Current Status',
      '60': 'status',
      '70': 'Approved',
      '80': 'Refused',
      '90': 'Remark',
      '100': 'Letter Format',
      '110': 'Document No.',
      '120': 'No.of  selected',
      '130': 'Record'
    },
    'HRES37UC3': {
      '0': 'Detail of Request',
      '10': 'Detail of Request',
      '20': 'Emp.Code  ',
      '30': 'Req.date',
      '40': 'Purpose of request',
      '50': 'Required Date',
      '60': 'Including Income',
      '70': 'Yes',
      '80': 'No',
      '90': 'รูปแบบใบรับรอง'
    }
  },
  th: {
    'HRES37UC1': {
      '0': 'อนุมัติการขอหนังสือรับรอง',
      '10': '[HRES37U] อนุมัติการขอหนังสือรับรอง',
      '20': 'ลำดับที่',
      '30': 'วันที่ขอ',
      '35': 'ลำดับที่',
      '40': 'รหัสพนักงาน',
      '50': 'ชื่อ - นามสกุล',
      '60': 'สถานะปัจจุบัน',
      '70': 'ผู้อนุมัติ',
      '80': 'วันที่อนุมัติ',
      '90': 'หมายเหตุการอนุมัติ',
      '100': 'ผู้อนุมัติลำดับถัดไป',
      '110': 'รูปแบบใบรับรอง'
    },
    'HRES37UC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'สำหรับพนักงาน',
      '20': 'ลำดับที่ในการอนุมัติ',
      '30': 'รหัสผู้อนุมัติ',
      '40': 'วันที่',
      '50': 'สถานะปัจจุบัน',
      '60': 'สถานะ',
      '70': 'อนุมัติ',
      '80': 'ไม่อนุมัติ',
      '90': 'หมายเหตุ',
      '100': 'รูปแบบจดหมาย',
      '110': 'เลขที่ใบรับรอง',
      '120': 'รายการที่เลือกทั้งหมด',
      '130': 'รายการ'
    },
    'HRES37UC3': {
      '0': 'รายละเอียดเพิ่มเติม',
      '10': 'รายละเอียดเพิ่มเติม',
      '20': 'รหัสพนักงาน   ',
      '30': 'วันที่ขอ',
      '40': 'วัตถุประสงค์เพื่อ',
      '50': 'วันที่ต้องการ',
      '60': 'ต้องการระบุรายได้',
      '70': 'แสดง',
      '80': 'ไม่แสดง',
      '90': 'รูปแบบใบรับรอง'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres37u.js